import React, { useState, useEffect } from 'react';
import Branches from '../../Components/Branches/Branches'
import styles from '../../Components/Branches/Branches.module.css'; 
import SearchComponent from '../../Components/Utilities/SearchComponent'
import { useTranslation } from "react-i18next";
import { useDispatch , useSelector} from 'react-redux';
import {getAllBranches} from '../../redux/Slices/Branches/thunk'
import { getCarts } from '../../redux/Slices/Cart/thunk';




const BranchesPage = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const [selectedOption, setSelectedOption] = useState(null);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(()=>{
    dispatch(getAllBranches())
    dispatch(getCarts({id:user?.cln_key}))
  },[])

  const branches = useSelector((state) => state.BranchesSlice);

console.log("branches",branches?.Branches)
  // Example options array
  const options = Array.isArray(branches?.Branches) ? branches.Branches.map((branch) => ({
    value: branch.brn_num,
    label: currentLanguage === "ar"
      ? `${branch.brn_nam.trim()} ` // Arabic branch name
      : (branch.brn_enm.trim() !== ""
      ? `${branch.brn_enm.trim()} ` // English branch name
      : `${branch.brn_nam.trim()} `), // Fallback to Arabic if English name is empty
  })) : [];
  
  // Handle onChange
  const handleChange = (selected) => {
    setSelectedOption(selected);
    console.log("Selected:", selected);
  };

  const filteredBranches = selectedOption
  ? branches?.Branches.filter(
      (branch) => branch.brn_num === selectedOption.value
    )
  : branches?.Branches;

  return (
    <div className='flex-grow-1'>
    <div style={{ padding: '20px', maxWidth: '1000px', margin:"auto" }}>
    <SearchComponent
        options={options}
        onChange={handleChange}
        placeholder=""
        labelForOption="label"
        valueForOption="value"
        noOptionsMessage={t("no_matching_branches")}
      />
      </div>  
      

    <div className={styles.loginContainer}>
    <div className={styles.loginHeader}>{t("Branches")}</div>

      </div>
<Branches branches={filteredBranches} loading={branches?.loading} />
    </div>
  )
}
export default BranchesPage;
